import React, { useEffect, useState } from "react";
import { Box, Grid, Skeleton } from "@mui/material";
import SiPagination from "../custom-table/pagination";

const CardsList = ({
  data = {},
  itemGridSize = 3,
  renderCardFunc,
  isLoading = false,
  filters,
  onChange,
}) => {
  const [results, setResults] = useState([]);
  const [page, setPage] = useState(1);
  useEffect(() => {
    if (Number.isInteger(parseInt(filters?.page))) {
      setPage(filters.page);
    }
  }, [filters]);
  useEffect(() => {
    if (isLoading) {
      setResults(Array.from(new Array(8)));
    } else {
      setResults(data.results || []);
    }
  }, [isLoading]);
  return (
    <div>
      <Grid container spacing={5}>
        {results?.map((ele, index) => {
          return (
            <Grid
              item
              md={itemGridSize}
              key={ele?.id || index}
              className="page-load"
            >
              {isLoading ? (
                <Skeleton variant="rounded" width="100%" height={300} />
              ) : (
                renderCardFunc(ele)
              )}
            </Grid>
          );
        })}
      </Grid>
      {!isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <SiPagination
            pageCount={data?.totalPages}
            page={page}
            setPage={setPage}
            onChange={onChange}
          />
        </Box>
      )}
    </div>
  );
};

export default CardsList;
